import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Form, Modal } from 'react-bootstrap';

function SendGDSNManufacturerProductsModal({ show, onHide, manufacturer, onSubmit, loading }) {
  const [archiveProducts, setArchiveProducts] = useState(false);

  const handleClose = () => {
    setArchiveProducts(false);
    onHide();
  };

  const handleSubmit = () => {
    onSubmit(archiveProducts);
    setArchiveProducts(false);
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Send Products to C&D</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {manufacturer && (
          <>
            <p>
              Send GDSN products for <strong>{manufacturer.name}</strong> to Cut & Dry.
            </p>
            <Form.Group className="mb-3">
              <Form.Check
                type="checkbox"
                id="archive-products-checkbox"
                label="Archive products not in GDSN"
                checked={archiveProducts}
                onChange={e => setArchiveProducts(e.target.checked)}
              />
              <Form.Text className="text-muted">
                If checked, products in C&D that are not in the GDSN product list for this
                manufacturer will be archived.
              </Form.Text>
            </Form.Group>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSubmit} disabled={loading}>
          {loading ? 'Sending...' : 'Send Products'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

SendGDSNManufacturerProductsModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  manufacturer: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

export default SendGDSNManufacturerProductsModal;
